var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconEmail = function SvgIconEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2D2D2D",
    d: "M0 0h25v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-656-6278h1920V125H-656z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    d: "M-656-256h1920v381H-656z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.7 20c-.4 0-.76-.15-1.06-.45q-.45-.45-.45-1.05v-13q0-.6.45-1.05T3.69 4h17q.6 0 1.05.45t.45 1.05v13q0 .6-.45 1.05t-1.05.45h-17Zm8.5-7.55L3.7 6.88V18.5h17V6.87zm0-1.5 8.4-5.45H3.81l8.37 5.45ZM3.7 6.88V5.5v13V6.87Z"
  })));
};
export default SvgIconEmail;